import { Divider } from "@mui/material";
import MDButton from "components/MDButton";
import ModalComponent from "components/Modal";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CadastrarHorariosDeAtendimentoPorCategoria } from "store/actions/parceiros";

function DefinirHorarios({ open, close, data }) {
  const { horariosCategorias } = useSelector((state) => state.parceiros);

  const [horariosAtendimento, setHorariosAtendimento] = useState([]);

  function CloseModalFnc() {
    close();
  }

  const formatarHorariosCadastr = horariosAtendimento.map((horario) => {
    return {
      dia_semana:
        horario.dia_semana === 1
          ? "domingo"
          : horario.dia_semana === 2
          ? "segunda_feira"
          : horario.dia_semana === 3
          ? "terca_feira"
          : horario.dia_semana === 4
          ? "quarta_feira"
          : horario.dia_semana === 5
          ? "quinta_feira"
          : horario.dia_semana === 6
          ? "sexta_feira"
          : "sabado",

      hora_inicio: horario.hora_inicio,
      hora_termino: horario.hora_termino,
      aberto: horario.aberto ? true : false,
      percentual_desconto: horario.percentual_desconto,
      limite_cupom_diario: horario.limite_cupom_diario,
    };
  });

  async function CadastrarHorarios() {
    const dataCadastro = { horarios: formatarHorariosCadastr };
    try {
      await CadastrarHorariosDeAtendimentoPorCategoria(data.id, dataCadastro);
      close();
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    if (horariosCategorias.length === 0) {
      // Se não houver horários, preencha todos os dias com "00:00"
      const horariosPadrao = Array.from({ length: 7 }, (_, index) => ({
        id: index + 1,
        dia_semana: index + 1,
        hora_inicio: "00:00",
        hora_termino: "00:00",
        aberto: 0,
        wl_parceiros_categorias: 1,
        percentual_desconto: 0.00,
        limite_cupom_diario: 0
      }));
      setHorariosAtendimento(horariosPadrao);
    } else {
      // Ordena os horários por dia_semana
      const horariosOrdenados = [...horariosCategorias].sort((a, b) => a.dia_semana - b.dia_semana);
      setHorariosAtendimento(horariosOrdenados);
    }
  }, [horariosCategorias]);

  const handleChange = (diaSemana, field, value) => {
    const novosHorarios = horariosAtendimento.map((horario) => {
      if (horario.dia_semana === diaSemana) {
        return {
          ...horario,
          [field]: value,
        };
      }
      return horario;
    });
    setHorariosAtendimento(novosHorarios);
  };

  return (
    <ModalComponent open={open} width="50%">
      <span>
        Defina os horários de atendimento para <b>{data?.categoria}</b>
      </span>
      <Divider />
      <table style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ fontSize: 12, textAlign: "left" }}>
            <th style={{ width: "15%" }}>Dia</th>
            <th style={{ width: "15%" }}>Horário de Início</th>
            <th style={{ width: "15%" }}>Horário de Término</th>
            <th style={{ width: "15%" }}>Aberto</th>
            <th style={{ width: "15%" }}>% de desconto</th>
            <th style={{ width: "25%" }}>Limite uso diário por usuário</th>
          </tr>
        </thead>
        <tbody>
          {horariosAtendimento &&
            horariosAtendimento.map((horario) => (
              <tr key={horario.id} >
                <td style={{ fontSize: 14 }}>
                  {horario.dia_semana === 1
                    ? "Domingo"
                    : horario.dia_semana === 2
                    ? "Segunda Feira"
                    : horario.dia_semana === 3
                    ? "Terça Feira"
                    : horario.dia_semana === 4
                    ? "Quarta Feira"
                    : horario.dia_semana === 5
                    ? "Quinta Feira"
                    : horario.dia_semana === 6
                    ? "Sexta Feira"
                    : "Sábado"}
                </td>

                <td>
                  <input
                    type="time"
                    value={horario.hora_inicio}
                    onChange={(e) =>
                      handleChange(horario.dia_semana, "hora_inicio", e.target.value)
                    }
                    disabled={horario.aberto === 0}
                  />
                </td>
                <td>
                  <input
                    type="time"
                    value={horario.hora_termino}
                    onChange={(e) =>
                      handleChange(horario.dia_semana, "hora_termino", e.target.value)
                    }
                    disabled={horario.aberto === 0}
                  />
                </td>
                <td style={{ fontSize: 12, fontWeight: "bold" }}>
                  <input
                    type="checkbox"
                    checked={horario.aberto === 1}
                    onChange={(e) =>
                      handleChange(horario.dia_semana, "aberto", e.target.checked ? 1 : 0)
                    }
                  />
                  &nbsp;{" "}
                  {horario.aberto ? (
                    <span style={{ color: "green" }}>Aberto</span>
                  ) : (
                    <span style={{ color: "red" }}>Fechado</span>
                  )}
                </td>
                <td >
                  <input
                    type="text"
                    style={{width: 100}}
                    value={horario.percentual_desconto}
                    onChange={(e) =>
                      handleChange(horario.dia_semana, "percentual_desconto", e.target.value)
                    }
                    disabled={horario.aberto === 0}
                  />
                </td>
                <td >
                  <input
                    type="text"
                    style={{width: 100}}
                    value={horario.limite_cupom_diario}
                    onChange={(e) =>
                      handleChange(horario.dia_semana, "limite_cupom_diario", e.target.value)
                    }
                    disabled={horario.aberto === 0}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <div style={{ marginTop: 15 }}>
        <MDButton variant="gradient" color="info" fullWidth onClick={() => CadastrarHorarios()}>
          Salvar Alterações
        </MDButton>
        <br/>
        <MDButton variant="gradient" color="primary" style={{marginTop: 15}} fullWidth onClick={() => CloseModalFnc()}>
        Fechar
        </MDButton>
      </div>
    </ModalComponent>
  );
}

export default DefinirHorarios;
